module.exports = __webpack_public_path__ + "static/media/37.5b7aef6d.png";